import { render } from "./JobSelector.vue?vue&type=template&id=121b36a5&scoped=true"
import script from "./JobSelector.vue?vue&type=script&lang=js"
export * from "./JobSelector.vue?vue&type=script&lang=js"

import "./JobSelector.vue?vue&type=style&index=0&id=121b36a5&scoped=true&lang=scss"

import exportComponent from "/codebuild/output/src3554799265/src/syndesi-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-121b36a5"]])

export default __exports__